import React from "react";
import { Skeleton, SkeletonText, Stack } from "@chakra-ui/react";

const LoadingState = () => {
  return (
    <Stack spacing={3}>
      <Skeleton height="18px" />
      <SkeletonText noOfLines={4} spacing="3" />
    </Stack>
  );
};

export default LoadingState;
